import { useSearchParams } from "react-router-dom";
import ShoppingCategoryService from "../../../services/ShoppingCategoryService";
import { ShoppingCategory } from "../../../models";
import { useEffect, useState } from "react";
import { CreateShoppingCategory } from "./ui/buttons";
import ShoppingCategoriesTable from "./ui/shopping-categories-table";
import ShoppingCategoriesSkeleton from "./skeleton/shopping-categories-skeleton";

export default function ShoppingCategoryPage() {
  const [searchParams] = useSearchParams();
  const reload = searchParams.get("reload");
  const [shoppingCategories, setShoppingCategories] = useState<ShoppingCategory[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const api = new ShoppingCategoryService();
    let active = true;

    async function fetchShoppingCategories() {
      try {
        const categories = await api.getShoppingCategories();
        if (active) setShoppingCategories(categories);
      } catch (error) {
        console.error("Error fetching shopping categories:", error);
      } finally {
        if (active) setLoading(false);
      }
    }

    fetchShoppingCategories();
    return () => {
      active = false;
    };
  }, [reload]);

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between">
        <h1 className=" text-2xl">Shopping Categories</h1>
      </div>
      <CreateShoppingCategory />
      {loading ? (
        <ShoppingCategoriesSkeleton />
      ) : (
        <ShoppingCategoriesTable shoppingCategories={shoppingCategories} />
      )}
    </div>
  );
}
